import styled from "styled-components";

export const StyledDatepicker = styled.div`
  ${({ mt }) => mt && `margin-top: ${mt}px`};
  ${({ mb }) => mb && `margin-bottom: ${mb}px`};
  display: grid;
  grid-template-columns: 100%;
  .react-date-picker__wrapper {
    padding: 7.75px 20px;
    background-color: #fff;
    border: 1px solid transparent;
    border-radius: 5px;
    box-shadow: 0px 1px 4px rgb(25 54 54 / 50%);
    cursor: pointer;
    z-index: 5;
    input, span {
      height: 100%;
      display: inline-flex;
      color: #262626;
      font-size: 14px;
    }
    button {
      height: 27px;
      width: 27px;
      margin: 3px;
      padding: 5px 3px;
      background-color: transparent;
      border: 1px solid rgba(25, 54, 54, 0.5);
      border-radius: 3px;
      outline: none;
      svg {
        height: 14px;
        stroke: rgba(25, 54, 54, 0.5);
      }
      &:hover, &:focus {
        background-color: rgba(55, 55, 55, 0.15);
        svg {
          stroke: #193636 !important;
        }
      }
      &:active {
        transform: scale(0.95);
      }
    }
  }
  .react-date-picker__calendar {
    z-index: 15;
  }
  .react-calendar {
    border: 1px solid transparent;
    border-radius: 5px;
    box-shadow: 0px 1px 4px rgb(25 54 54 / 50%);
    .react-calendar__navigation__arrow,
    .react-calendar__navigation__label,
    .react-calendar__tile {
      &:hover {
        color: #fff;
        background-color: #193636;
        border-radius: 3px;
      }
    }
    .react-calendar__month-view__days__day--weekend {
      color: #f44336;
    }
    .react-calendar__tile--now, .react-calendar__tile--active {
      border-radius: 3px;
    }
    .react-calendar__tile--now {
      color: #fff;
      background-color: #1a4e4e;
    }
    .react-calendar__tile--active {
      color: #fff;
      background-color: #1a4e4e;
    }
    .react-calendar__navigation button:enabled:hover, .react-calendar__navigation button:enabled:focus {
      color: #fff;
      background-color: #193636;
    }
    .react-calendar__navigation button[disabled] {
      background-color: inherit;
      opacity: 0.5;
    }
  }
`;

export const StyledDatepickerLabel = styled.label`
  padding-bottom: 3px;
  color: #717A86;
  font-size: 14px;
  text-align: left;
`;